:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fd-column{flex-direction:column;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._pb-t-space-med104641{padding-bottom:var(--t-space-medium);}
:root ._borderBottomWidth-1px{border-bottom-width:1px;}
:root ._borderBottomColor-divider{border-bottom-color:var(--divider);}
:root ._borderBottomStyle-solid{border-bottom-style:solid;}
:root ._pos-absolute{position:absolute;}
:root ._r-0px{right:0px;}
:root ._t-0px{top:0px;}
:root ._bg-background35{background-color:#background;}